//collections
export const COMPETITION_COLLECTION_CACHE = 'competition-collections';
export const COLLECTION_VALIDITY_CACHE = 'collection_validity_cache';
export const FANTASY_RECENT_COLLECTIONS_CACHE = 'competition-recent-collections';
export const ADMIN_COMPETITION_COLLECTION_CACHE = 'admin-competition-collections';

export const COLLECTION_STATUS_QUERIES = [
    COMPETITION_COLLECTION_CACHE,
    ADMIN_COMPETITION_COLLECTION_CACHE,
    COLLECTION_VALIDITY_CACHE,
];

// wishlists/lineups
export const WISHLIST_PORTFOLIO_SUMMARY_CACHE = 'WISHLIST_SUMMARY_CACHE';
export const WISHLIST_SUMMARY_CACHE = [WISHLIST_PORTFOLIO_SUMMARY_CACHE];
